module.exports = __webpack_public_path__ + "media/app/images/close-icon-e5cc471cfb2e88e7051bed9320fdf711.png";